{
  "codexEntityForm": {
    "character": "인물",
    "place": "장소",
    "faction": "세력",
    "object": "사물",
    "concept": "개념",
    "editName": "{{name}} 편집",
    "newCodexEntry": "새 코덱스 항목",
    "theWorldHasChangedTheDraft": "세계관이 변경되었어요. 초안은 유지돼요. 저장하기 전에 항목을 다시 불러오세요.",
    "portraitChooseAnImage": "초상화: 이미지 선택",
    "change": "변경",
    "addPortrait": "초상화 추가",
    "portraitImage": "초상화 이미지",
    "entryName": "항목 이름",
    "name": "이름",
    "entryType": "항목 유형",
    "customCategory": "사용자 지정 카테고리",
    "categoryEGDeityShipSpell": "카테고리 (예: 신, 배, 주문)",
    "aliases": "별칭",
    "entryAliases": "항목 별칭",
    "otherNamesOneAtATime": "다른 이름을 하나씩 입력…",
    "tags": "태그",
    "entryTags": "항목 태그",
    "themesRolesArcs": "주제, 역할, 서사 흐름…",
    "collection": "컬렉션",
    "entryCollection": "항목 컬렉션",
    "noCustomCollection": "사용자 지정 컬렉션 없음",
    "folder": "폴더",
    "entryFolder": "항목 폴더",
    "unfiled": "분류 안 됨",
    "notes": "노트",
    "entryNotes": "항목 노트",
    "whoTheyAreWhatTheyWant": "누구인지, 무엇을 원하는지, 독자가 너무 일찍 알면 안 되는 것은…",
    "entryFields": "항목 필드",
    "fields": "필드",
    "fieldTemplate": "필드 템플릿",
    "template": "템플릿…",
    "schemaOf": "스키마:",
    "addMissingFields": "누락된 필드 추가",
    "addField": "필드 추가",
    "noCustomFieldYetFieldsGive": "아직 사용자 지정 필드가 없어요. 필드는 나이, 소속, 비밀처럼 검사가 판단에 쓸 수 있는 구조화된 정보를 항목에 더해 줘요.",
    "sharedFieldNamesTypesAndOptions": "공통 필드의 이름, 유형, 옵션은 컬렉션 설정에서 관리해요. 값은 이 페이지에 속해요.",
    "fieldNameN": "필드 이름 {{n}}",
    "fieldName": "필드 이름",
    "fieldTypeN": "필드 유형 {{n}}",
    "unknown": "알 수 없음",
    "fieldValueN": "필드 값 {{n}}",
    "select": "선택…",
    "yes": "예",
    "no": "아니요",
    "value": "값",
    "chooseAnEntry": "항목 선택…",
    "eGSpringOfYear12": "예: 12년째 봄, 또는 포위전이 벌어진 날",
    "below": "아래",
    "unknownValueN": "알 수 없는 값 {{n}}",
    "required": "필수",
    "sharedField": "공통 필드",
    "remove": "삭제",
    "confirmRemoval": "삭제 확인",
    "paragraph": "문단",
    "aFewLines": "몇 줄 적어 보세요…",
    "discardTheDraft": "초안을 버릴까요?",
    "confirmReload": "다시 불러오기 확인",
    "keepEditing": "계속 편집",
    "reloadEntry": "항목 다시 불러오기",
    "cancel": "취소",
    "chooseAnImageFileForThe": "초상화로 쓸 이미지 파일을 선택하세요.",
    "thePortraitMustBeUnder8": "초상화는 8MiB 이하여야 해요.",
    "saveEntry": "항목 저장",
    "searchEntries": "항목 검색…"
  },
  "codexEntryDialog": {
    "newCodexEntry": "새 코덱스 항목",
    "savedToWorldCodexTheManuscript": "세계관 › 코덱스에 저장했어요. 원고에서는 입력하던 위치에 이 항목을 언급해요.",
    "createAndMention": "만들고 언급하기"
  },
  "continuityPanel": {
    "relationsOverTime": "시간에 따른 관계",
    "checkingRelations": "관계를 검사하는 중…",
    "cancel": "취소",
    "theProjectHasChangedRunThe": "이번 실행 이후 원고나 세계관이 변경되었어요. 검사를 다시 실행해 관계를 새로 고침하세요.",
    "anAnalysisLimitWasReachedThe": "분석 한도에 도달했어요. 결과가 일부만 표시돼요.",
    "ruleApplied": "규칙: “{{label}}”, {{rule}}.",
    "oneSourcePerTarget": "대상당 출처 하나",
    "oneTargetPerSource": "출처당 대상 하나",
    "interval": "{{start}}부터 {{end}}까지",
    "openScene": "{{scene}} 열기",
    "findingReferenceMissing": "더 이상 존재하지 않는 항목을 가리키고 있어요.",
    "findingConfirmedWithoutEvidence": "본문 인용 없이 확정되어 출처를 확인할 수 없어요.",
    "findingEvidenceMissing": "의존하던 인용이 사라졌어요.",
    "findingEvidenceNotCurrent": "의존하는 인용이 확정되지 않았거나 더 이상 본문과 일치하지 않아요.",
    "findingExclusiveNotEvaluable": "규칙에 따라 검사할 수 없어요. 방향, 양쪽 끝, 완전한 기간이 필요해요.",
    "findingExclusiveOverlap": "이 중 둘이 동시에 성립해요. 규칙상 허용되지 않아요.",
    "findingOther": "이 관계에서 확인할 부분이 있어요.",
    "theProjectExceedsTheLimitOf": "프로젝트가 이 분석의 한도를 초과했어요. 데이터는 변경되지 않았어요.",
    "theAnalysisExceededItsExecutionLimit": "분석이 실행 한도를 초과했어요. 데이터는 변경되지 않았어요.",
    "analysisCancelled": "분석을 취소했어요.",
    "checksNotCompletedTheTextAnd": "검사를 완료하지 못했어요. 본문과 정설은 변경되지 않았어요."
  },
  "eventTimelinePanel": {
    "eventHistory": "이벤트 기록",
    "timeline": "타임라인",
    "newEvent": "새 이벤트",
    "searchEvents": "이벤트 검색",
    "searchEvents2": "이벤트 검색…",
    "timelineOrder": "타임라인 순서",
    "storyTime": "이야기 속 시간",
    "readingOrder": "읽는 순서",
    "dateStatus": "날짜 상태",
    "allDates": "모든 날짜",
    "resolvedDates": "확정된 날짜",
    "unresolvedDates": "미확정 날짜",
    "filterEventsByScene": "장면으로 이벤트 필터",
    "allScenes": "모든 장면",
    "scenes": "장면",
    "editEvent": "이벤트 편집",
    "closeEventEditor": "이벤트 편집기 닫기",
    "theWorldHasChangedReloadThe": "세계관이 변경되었어요. 저장하기 전에 이벤트를 다시 불러오세요. 초안 필드는 유지돼요.",
    "eventTitle": "이벤트 제목",
    "whatHappens": "일어나는 일",
    "scene": "장면",
    "eventScene": "이벤트 장면",
    "notLinked": "연결 안 됨",
    "removedSceneSceneid": "삭제된 장면 — {{sceneId}}",
    "dateType": "날짜 유형",
    "eventDateType": "이벤트 날짜 유형",
    "unknown": "알 수 없음",
    "definedInterval": "정해진 기간",
    "relativeToAnEvent": "다른 이벤트 기준",
    "start": "시작",
    "eventStart": "이벤트 시작",
    "endExclusive": "끝(미포함)",
    "eventEnd": "이벤트 끝",
    "referenceEvent": "기준 이벤트",
    "select": "선택…",
    "referenceToVerifyAnchoreventid": "확인할 기준 — {{anchorEventId}}",
    "events": "이벤트",
    "offsetInTicks": "틱 단위 오프셋",
    "eventOffset": "이벤트 오프셋",
    "saveEvent": "이벤트 저장",
    "closeReload": "닫기 / 다시 불러오기…",
    "discardTheDraftChanges": "초안 변경 사항을 버릴까요?",
    "discardDraft": "초안 버리기",
    "reloadEvent": "이벤트 다시 불러오기",
    "keepEditing": "계속 편집",
    "noEventMatchesTheseFiltersEvents": "이 필터에 맞는 이벤트가 없어요. 이벤트는 검사가 판단하는 대상이에요. 언제 일이 일어났는지, 어느 장면에서 독자가 알게 되는지를 뜻해요.",
    "tickStart": "틱 {{start}}",
    "openScene": "장면 열기",
    "editTitle": "{{title}} 편집",
    "removeTitle": "{{title}} 삭제",
    "confirmEventRemoval": "이벤트 삭제 확인",
    "cancel": "취소",
    "theWorldHasChangedCancelAnd": "세계관이 변경되었어요. 취소하고 확인 창을 다시 여세요.",
    "resolvedDate": "확정된 날짜",
    "unknownDate": "알 수 없는 날짜",
    "missingReference": "누락된 참조",
    "timeCycle": "시간 순환",
    "dateOutOfRange": "범위를 벗어난 날짜",
    "eventsFoundOfTotal_other": "이벤트 {{count}}개 찾음 · 전체 {{total}}개",
    "removeThisEventReferences_other": "이 이벤트를 삭제할까요? 직접 참조 {{count}}건을 확인해야 합니다.",
    "showMoreEvents_other": "이벤트 {{count}}개 더 보기"
  },
  "fieldEditor": {
    "choose": "선택…",
    "labelSearch": "{{label}} 검색",
    "search": "검색…",
    "labelOptions": "{{label}} 옵션",
    "noMatch": "일치하는 항목이 없어요.",
    "optionsOnePerLine": "옵션 (한 줄에 하나)",
    "fieldOptionsIndex": "필드 옵션 {{index}}",
    "addOptionIndex": "옵션 {{index}} 추가",
    "newOption": "새 옵션",
    "addOption": "옵션 추가",
    "fieldValueIndex": "필드 값 {{index}}",
    "chooseOptions": "옵션 선택…",
    "chooseEntries": "항목 선택…",
    "unsupportedMultiValueEditor": "지원하지 않는 다중 값 편집기"
  },
  "graphExplorer": {
    "relationGraph": "관계 그래프",
    "entry": "항목",
    "filterGraphByEntry": "항목으로 그래프 필터",
    "all": "전체",
    "status": "상태",
    "graphRelationStatus": "그래프 관계 상태",
    "proposedAndConfirmed": "제안됨 및 확정됨",
    "confirmed": "확정됨",
    "proposed": "제안됨",
    "relation": "관계",
    "searchRelationInTheGraph": "그래프에서 관계 검색",
    "filterAtStoryTime": "이야기 속 시간으로 필터",
    "tick": "틱",
    "graphTick": "그래프 틱",
    "includeUnknownTime": "알 수 없는 시간 포함",
    "enterANumericTickOrTurn": "숫자 틱을 입력하거나 시간 필터를 꺼 주세요.",
    "navigableRelationGraph": "탐색 가능한 관계 그래프",
    "selectName": "{{name}} 선택",
    "entryCount_other": "항목 {{count}}개",
    "relationCount_other": "관계 {{count}}개",
    "hiddenBeyondViewLimit": "표시 한도를 넘은 항목과 관계: {{entries}}, {{relations}}.",
    "relationsWithMissingEntries_other": "항목이 없는 관계 {{count}}개.",
    "unknownDurationIncluded_other": "기간을 알 수 없는 관계 {{count}}개가 필터에 포함되어 있습니다.",
    "unknownDurationExcluded_other": "기간을 알 수 없는 관계 {{count}}개가 필터에 포함되어 있지 않습니다."
  },
  "relationshipPanel": {
    "select": "선택…",
    "removedReference": "삭제된 참조:",
    "projectRelations": "프로젝트 관계",
    "relationsOf": "다음 항목의 관계:",
    "filterRelationsByEntry": "항목으로 관계 필터",
    "allEntries": "모든 항목",
    "searchEntries": "항목 검색…",
    "searchRelations": "관계 검색",
    "relationOrEntry": "관계 또는 항목",
    "newRelation": "새 관계",
    "editRelation": "관계 편집",
    "relationsLinkTwoEntries": "관계는 두 항목을 연결해요",
    "addTwoEntriesInTheCodex": "코덱스에 항목을 두 개 이상 추가한 뒤, 둘을 잇는 말을 적어 보세요. 예: “~의 멘토다”.",
    "theWorldHasChangedTheFields": "열려 있는 동안 세계관이 변경되었어요. 입력한 필드는 유지돼요. 새 데이터 기준으로 저장하려면 다시 불러오세요.",
    "reload": "다시 불러오기",
    "anEntry": "항목",
    "anotherEntry": "다른 항목",
    "relationSource": "관계 출처",
    "relationType": "관계 유형",
    "isTheMentorOf": "~의 멘토다",
    "relationTarget": "관계 대상",
    "direction": "방향",
    "relationDirection": "관계 방향",
    "oneWay": "단방향",
    "bothWays": "양방향",
    "when": "시점",
    "relationTime": "관계 시점",
    "notSet": "설정 안 됨",
    "betweenTwoMoments": "두 시점 사이",
    "fromAnEvent": "이벤트부터",
    "from": "시작:",
    "to": "끝:",
    "relationStart": "관계 시작",
    "relationEnd": "관계 끝",
    "momentsHint": "세계관 타임라인 위의 시점이에요. 끝은 포함하지 않아요.",
    "event": "이벤트",
    "relationEvent": "관계 이벤트",
    "offset": "오프셋",
    "relationOffset": "관계 오프셋",
    "offsetHint": "이벤트 이후의 시점이에요. 이전은 음수로 입력하세요.",
    "status": "상태",
    "relationStatus": "관계 상태",
    "proposed": "제안됨",
    "confirmed": "확정됨",
    "rejected": "거절됨",
    "superseded": "대체됨",
    "confirmedRelationsCountAsCanonIn": "확정된 관계는 검사에서 정설로 간주돼요.",
    "notes": "노트",
    "relationNotes": "관계 노트",
    "howTheStoryShowsItAnd": "이야기에서 어떻게 드러나는지, 무엇이 모호하게 남는지 적어 보세요.",
    "quotes": "인용",
    "linkQuotes": "본문 인용 연결",
    "quotesLinked": "인용 {{count}}개",
    "searchQuotations": "인용 검색",
    "excerptOrNote": "발췌 또는 노트",
    "removedQuotation": "삭제된 인용:",
    "noQuotationYetAnnotateAPassage": "아직 인용이 없어요. 원고의 구절에 주석을 달면 여기에서 인용할 수 있어요.",
    "upTo100QuotationsShownUse": "인용은 최대 100개까지 표시돼요. 검색으로 범위를 좁히세요.",
    "saveRelation": "관계 저장",
    "cancel": "취소",
    "aDeletedEntry": "삭제된 항목",
    "aDeletedEvent": "삭제된 이벤트",
    "timeBetween": "{{start}}부터 {{end}}까지",
    "timeAtEvent": "{{event}} 시점",
    "timeAfterEvent": "{{event}} + {{offset}}",
    "timeBeforeEvent": "{{event}} − {{offset}}",
    "noRelationsYet": "아직 관계가 없어요.",
    "noRelationMatches": "일치하는 관계가 없어요.",
    "edit": "편집",
    "editCaption": "{{caption}} 편집",
    "remove": "삭제",
    "removeCaption": "{{caption}} 삭제",
    "removeThisRelationTheChangeStays": "이 관계를 삭제할까요? 변경 내용은 기록에 남아요.",
    "confirmRemoval": "삭제",
    "shownOfTotal": "관계 {{total}}개 중 100개를 표시해요. 검색으로 범위를 좁혀 나머지를 보세요.",
    "theWorldHasChangedReloadThe": "세계관이 변경되었어요. 저장하기 전에 관계를 다시 불러오세요.",
    "theRelationWasChangedOrRemoved": "관계가 변경되었거나 삭제되었어요. 데이터를 다시 불러오세요.",
    "explicitlyConfirmTheRelationBeforeSaving": "이 관계를 정설로 만들려면 ‘확정됨’을 다시 선택하세요.",
    "selectTwoEntriesThatExistIn": "코덱스에 있는 항목을 두 개 선택하세요.",
    "fillInTheTimeValuesOr": "시점을 입력하거나 ‘설정 안 됨’을 선택하세요.",
    "enterAValidIntervalTheEnd": "끝은 시작보다 뒤여야 해요.",
    "selectAnExistingEventAsThe": "아직 존재하는 이벤트를 선택하세요.",
    "theSelectedQuotationIsNoLonger": "선택한 인용이 더 이상 존재하지 않아요.",
    "checkTheRelationTextAndThe": "관계의 문구와 노트를 확인하세요.",
    "theChangeWasNotSavedReload": "변경 내용을 저장하지 못했어요. 데이터를 다시 불러오고 다시 시도해 주세요."
  },
  "useWorldReplication": {
    "signInToTheLinkedAccount": "연결된 계정에 로그인하고 프로젝트 접근 권한을 확인하세요. 로컬 변경 사항은 유지돼요.",
    "syncTheManuscriptWithThisServer": "세계관을 연결하기 전에 원고를 이 서버와 동기화하세요.",
    "theWorldChangedAfterTheComparison": "비교 이후 세계관이 변경되었어요. 현재 사본을 다시 검토하세요.",
    "aConfirmationOrRestoredRecordNeeds": "확정 또는 복원된 기록은 동기화하기 전에 명시적인 검토가 필요해요.",
    "anAttachmentOrRemoteCopyFailed": "첨부 파일이나 원격 사본의 검증에 실패했어요. 로컬 세계관은 유지돼요.",
    "theseChangesExceedASyncLimit": "이 변경 사항이 동기화 한도를 초과했거나 함께 적용되어야 해요. 로컬 세계관과 대기 중인 변경 사항은 유지돼요.",
    "syncPausedYourLocalChangesAre": "동기화가 일시 중지되었어요. 로컬 변경 사항은 유지돼요.",
    "newMapNeedsPlan": "새 지도는 Ink와 Press에서 제공해요. 지도는 이 기기에 남고 세계관은 대기해요. 다시 동기화하려면 새 지도를 삭제하거나 요금제를 선택하세요.",
    "worldSyncCouldNotFinishCheck": "세계관 동기화를 완료하지 못했어요. 연결을 확인하고 다시 시도해 주세요. 로컬 변경 사항은 유지돼요."
  },
  "vaultFolders": {
    "folderName": "{{name}} 폴더",
    "editFolder": "폴더 편집",
    "newSubfolder": "새 하위 폴더",
    "moveContentsBeforeRemoving": "삭제하기 전에 내용을 옮겨 주세요",
    "removeFolder": "폴더 삭제",
    "folderActionsName": "{{name}} 폴더 작업",
    "chooseThisFolderWhenEditingA": "페이지를 편집할 때 이 폴더를 선택하세요.",
    "projectFolders": "프로젝트 폴더",
    "folders": "폴더",
    "newFolder": "새 폴더",
    "groupPagesFromAnyCollection": "어느 컬렉션의 페이지든 묶을 수 있어요.",
    "foldersOrganizePagesWithoutChangingTheir": "폴더는 페이지의 컬렉션이나 내용을 바꾸지 않고 정리해 줘요.",
    "cancel": "취소",
    "saveFolder": "폴더 저장",
    "name": "이름",
    "folderName2": "폴더 이름",
    "inside": "위치",
    "parentFolder": "상위 폴더",
    "projectRoot": "프로젝트 루트",
    "removeEmptyFolder": "빈 폴더를 삭제할까요?",
    "removeNameFromTheProject": "프로젝트에서 “{{name}}” 폴더를 삭제할까요?"
  },
  "vaultTable": {
    "unavailableEntry": "사용할 수 없는 항목",
    "vaultTable": "보관함 표",
    "pages": "페이지",
    "searchVaultTable": "보관함 표 검색",
    "searchPages": "페이지 검색…",
    "tableCollection": "표의 컬렉션",
    "allCollections": "모든 컬렉션",
    "noCustomCollection": "사용자 지정 컬렉션 없음",
    "tableFolder": "표의 폴더",
    "allFolders": "모든 폴더",
    "unfiled": "분류 안 됨",
    "scrollableVaultTable": "스크롤 가능한 보관함 표",
    "name": "이름",
    "collection": "컬렉션",
    "folder": "폴더",
    "noPagesMatchTheseFilters": "이 필터에 맞는 페이지가 없어요.",
    "none": "없음",
    "yes": "예",
    "no": "아니요",
    "pagesShown_other": "{{count}}페이지 중 {{shown}}페이지"
  },
  "vaultTree": {
    "blue": "파랑",
    "emerald": "에메랄드",
    "gold": "금색",
    "violet": "보라",
    "rose": "장미",
    "amber": "호박색",
    "teal": "청록",
    "slate": "슬레이트",
    "crimson": "진홍",
    "bark": "나무껍질",
    "forest": "숲",
    "navy": "네이비",
    "orchid": "난초",
    "saffron": "사프란",
    "ink": "잉크",
    "ember": "불씨",
    "concept": "개념",
    "character": "인물",
    "place": "장소",
    "faction": "세력",
    "object": "사물",
    "vault": "보관함",
    "newCollection": "새 컬렉션",
    "vaultView": "보관함 보기",
    "pages": "페이지",
    "table": "표",
    "pagesMarkedUnassignedKeepTheirPrevious": "‘미지정’으로 표시된 페이지는 이전 필드를 유지해요. 컬렉션을 정하려면 페이지를 편집하세요.",
    "filterPages": "페이지 필터",
    "filterPages2": "페이지 필터…",
    "worldVault": "세계관 보관함",
    "removeCollectionName": "컬렉션 {{name}} 삭제",
    "collectionSettingsForName": "{{name}} 컬렉션 설정",
    "iconAndColour": "아이콘 및 색상",
    "newPageInName": "{{name}}에 새 페이지",
    "noPageYetAddTheFirst": "아직 페이지가 없어요 — +로 첫 페이지를 추가하세요.",
    "nothingHereYet": "아직 아무것도 없어요.",
    "removeEmptyCollection": "빈 컬렉션을 삭제할까요?",
    "removeNameAndItsSchema": "“{{name}}” 컬렉션과 스키마를 삭제할까요?",
    "removeCollection": "컬렉션 삭제",
    "text": "텍스트",
    "theSvgMustBeUnder16": "SVG는 16KiB 이하여야 해요.",
    "thisFileIsNotAUsable": "사용할 수 없는 SVG 파일이에요(스크립트와 외부 참조는 제거되며, 루트는 <svg>여야 해요).",
    "collectionName": "컬렉션: {{name}}",
    "sharedFieldsApplyToEveryPage": "공통 필드는 이 컬렉션의 모든 페이지에 적용돼요. 각 페이지는 자체 필드도 가질 수 있어요.",
    "cancel": "취소",
    "saving": "저장 중…",
    "saveCollection": "컬렉션 저장",
    "createCollection": "컬렉션 만들기",
    "identity": "정체성",
    "nameAndIconAsTheTree": "트리와 페이지에 표시될 이름과 아이콘이에요.",
    "name": "이름",
    "collectionName2": "컬렉션 이름",
    "magic": "마법",
    "aCollectionWithThisNameAlready": "같은 이름의 컬렉션이 이미 있어요.",
    "icon": "아이콘",
    "iconSource": "아이콘 출처",
    "lucide181": "Lucide (181)",
    "yourSvg": "내 SVG",
    "collectionIcon": "컬렉션 아이콘",
    "searchLucideIcons": "Lucide 아이콘 검색",
    "searchIconsCastleSwordMoon": "아이콘 검색 — 성, 검, 달…",
    "loadingIcons": "아이콘 불러오는 중…",
    "lucideIcon": "Lucide 아이콘",
    "noIconMatches": "일치하는 아이콘이 없어요.",
    "chooseAnSvgFile": "SVG 파일 선택",
    "customSvgIcon": "사용자 지정 SVG 아이콘",
    "upTo16KibScriptsLinks": "최대 16KiB. 스크립트, 링크, 외부 참조는 제거돼요. 컬렉션 색상이 적용되도록 파일에 currentColor를 쓰세요.",
    "colour": "색상",
    "aPresetOneYouUsedRecently": "프리셋, 최근 쓴 색, 또는 색상환에서 직접 고른 색을 쓸 수 있어요.",
    "collectionColour": "컬렉션 색상",
    "recent": "최근",
    "useHex": "{{hex}} 사용",
    "kindOfPage": "페이지 종류",
    "everyPageIsACodexEntry": "모든 페이지는 한 가지 종류의 코덱스 항목이에요. 종류에 따라 검사, @ 멘션, 그래프의 처리 방식이 정해지고, 어디서나 같은 색을 유지해요.",
    "collectionBaseKind": "컬렉션 기본 종류",
    "magicOrShipsConceptDeitiesOr": "마법이나 배 → 개념 · 신이나 가문 → 인물 또는 세력 · 도시 컬렉션 → 장소.",
    "sharedFields": "공통 필드",
    "thePropertiesOfTheCollectionValues": "컬렉션의 속성이에요. 값은 각 페이지에 있고, 페이지는 자체 속성을 더할 수 있어요.",
    "collectionTemplate": "컬렉션 템플릿",
    "template": "템플릿…",
    "addField": "필드 추가",
    "exampleMagicLevelNumberRarityChoice": "예: 마법 → 레벨(숫자) · 희귀도(선택: 흔함, 희귀, 전설) · 습득(이야기 속 날짜) · 스승(항목 링크).",
    "collectionFieldNameValue": "컬렉션 필드 이름 {{value}}",
    "fieldName": "필드 이름",
    "collectionFieldTypeValue": "컬렉션 필드 유형 {{value}}",
    "collectionFieldOptionsValue": "컬렉션 필드 옵션 {{value}}",
    "optionsOnePerLine": "옵션 (한 줄에 하나)",
    "required": "필수",
    "requiredCollectionFieldValue": "필수 컬렉션 필드 {{value}}",
    "removeCollectionFieldValue": "컬렉션 필드 {{value}} 삭제",
    "yesNo": "예 / 아니요",
    "multipleChoice": "다중 선택",
    "storyDate": "이야기 속 날짜",
    "entryLink": "항목 링크",
    "multipleEntryLinks": "여러 항목 링크",
    "fieldParagraph": "문단",
    "fieldNumber": "숫자",
    "fieldChoice": "선택지"
  },
  "worldCloudPanel": {
    "worldCloudVersions": "세계관 클라우드 버전",
    "includesCodexPagesCollectionsFoldersFacts": "코덱스 페이지, 컬렉션, 폴더, 사실, 관계, 첨부 파일을 포함해요. 버전은 직접 게시하거나 다운로드해요. 원고는 장면 동기화를 사용해요.",
    "compareVersions": "버전 비교",
    "recoverPreviousWorld": "이전 세계관 복구…",
    "deviceRevision": "기기의 버전",
    "accountVersionRemoteversion": "계정 버전 {{remoteVersion}}",
    "firstAccountVersion": "첫 계정 버전",
    "uploadDeviceVersion": "기기 버전 업로드…",
    "useAccountVersion": "계정 버전 사용…",
    "confirmTransfer": "이전 확인",
    "replaceWorldOnThisDeviceWith": "이 기기의 세계관을 이 버전으로 교체할까요? 현재 세계관과 첨부 파일의 사본이 먼저 보관돼요. 원고 텍스트는 변경되지 않아요.",
    "saveThisCopyToYourAccount": "이 사본을 계정에 저장할까요? 이전 계정 버전은 보관돼요.",
    "restoreWorldFromBeforeTheLast": "마지막 이전 직전의 세계관으로 복원할까요? 이후 수정이 있으면 복원할 수 없어요.",
    "confirm": "확인",
    "cancel": "취소",
    "transferring": "이전하는 중…",
    "codexPages": "코덱스 페이지",
    "updateStoryideBeforePublishingChangesTo": "이 보관함의 변경 사항을 게시하기 전에 Musael을 업데이트하세요.",
    "theAccountVersionChangedCompareAgain": "계정 버전이 변경되었어요. 적용하기 전에 다시 비교하세요.",
    "worldChangedOnThisDeviceCompare": "이 기기의 세계관이 변경되었어요. 적용하기 전에 다시 비교하세요.",
    "accountVersionStorageIsFullPrevious": "계정 버전 저장 공간이 가득 찼어요. 이전 사본은 유지돼요.",
    "anAttachmentFailedItsIntegrityCheck": "첨부 파일이 무결성 검사를 통과하지 못했어요. 로컬 사본은 교체되지 않았어요.",
    "theAccountCopyFailedItsIntegrity": "계정 사본이 무결성 검사를 통과하지 못했어요.",
    "noRecoveryCopyIsAvailableFor": "이 이전에 사용할 수 있는 복구 사본이 없어요.",
    "anIdentifierIsAlreadyUsedIn": "식별자가 이미 다른 프로젝트에서 사용 중이에요.",
    "openOrSyncTheManuscriptWith": "먼저 원고를 계정에서 열거나 동기화하세요.",
    "yourAccountDoesNotHaveThe": "계정에 필요한 권한이 없어요.",
    "signInAgainThisSessionWas": "다시 로그인하세요. 이 세션은 해제되었어요.",
    "transferCancelled": "이전을 취소했어요.",
    "transferFailedCheckYourConnectionAnd": "이전하지 못했어요. 연결을 확인하고 다시 비교하세요.",
    "couldNotReadTheRecoveryCopy": "복구 사본을 읽지 못했어요.",
    "mondoPrecedenteRipristinato": "이전 세계관을 복원했어요.",
    "accountVersionVersionSaved": "계정 버전 {{version}} 저장 완료.",
    "versionVersionAppliedToWorldOn": "이 기기의 세계관에 적용했어요: 버전 {{version}}",
    "cancellationRequested": "취소를 요청했어요.",
    "labelFacts": "사실",
    "labelEvents": "이벤트",
    "labelKnowledge": "지식",
    "labelAnnotations": "주석",
    "labelRelationships": "관계",
    "labelAttachments": "첨부 파일",
    "labelCollections": "컬렉션",
    "labelFolders": "폴더",
    "changedCount_other": "변경 {{count}}건"
  },
  "worldMaps": {
    "character": "인물",
    "place": "장소",
    "object": "사물",
    "faction": "세력",
    "concept": "개념",
    "pinOf": "핀: {{name}}",
    "pinMissing": "누락된 항목의 핀",
    "missingEntry": "누락된 항목",
    "zoom": "확대/축소",
    "zoomIn": "확대",
    "zoomOut": "축소",
    "fitToView": "화면에 맞춤",
    "newMap": "새 지도",
    "newMapDescription": "장소 그림 위에 그곳의 인물, 장소, 사물을 핀으로 표시해요.",
    "cancel": "취소",
    "saving": "저장 중…",
    "createMap": "지도 만들기",
    "mapOf": "다음 장소의 지도:",
    "aNewPlace": "새 장소",
    "placeName": "장소 이름",
    "placeNamePlaceholder": "소금 해안",
    "picture": "그림",
    "choosePicture": "PNG, JPEG, WebP, GIF 선택",
    "pictureHint": "최대 16MB. 항목의 첨부 파일 중 하나가 돼요.",
    "maps": "지도",
    "mapsLead": "장소 그림에 항목을 핀으로 표시해요. 자체 지도가 있는 장소의 핀을 누르면 그 지도가 열려요.",
    "noMapsYet": "아직 지도가 없어요",
    "noMapsText": "장소에 그림을 넣고, 그곳에 속한 항목을 핀으로 표시하세요.",
    "addTheFirstMap": "첫 지도 추가",
    "onePin": "핀 1개",
    "pins": "핀 {{count}}개",
    "inPlace": "{{place}}에서",
    "chooseAnEntryOrName": "항목을 선택하거나 핀 이름을 입력하세요.",
    "mapTrail": "상위 지도",
    "doneAdding": "완료",
    "addPin": "핀 추가",
    "labels": "레이블",
    "replacePicture": "그림 교체",
    "removeMap": "지도 삭제",
    "hintClick": "핀을 놓을 위치를 지도에서 클릭하세요.",
    "hintChoose": "오른쪽에서 핀이 가리킬 대상을 선택하세요.",
    "pictureMissing": "이 지도의 그림이 아직 이 기기에 없어요.",
    "pinDetails": "핀 세부 정보",
    "newPin": "새 핀",
    "entry": "항목",
    "chooseAnEntry": "항목 선택",
    "noEntryLabelOnly": "항목 없이 레이블만",
    "labelOnTheMap": "지도의 레이블",
    "labelDefault": "항목의 이름",
    "labelRequired": "항목이 없으면 필요해요",
    "placePin": "핀 놓기",
    "label": "레이블",
    "openEntry": "항목 열기",
    "openItsMap": "해당 지도 열기",
    "position": "가로 {{x}}%, 세로 {{y}}%",
    "removePin": "핀 삭제",
    "noPinsYet": "아직 핀이 없어요. ‘핀 추가’를 누른 뒤 지도를 클릭하세요.",
    "shownOn": "표시된 곳:",
    "openEntryOf": "{{name}} 열기",
    "removeMapTitle": "{{name}}의 지도를 삭제할까요?",
    "removeMapMessage": "핀도 함께 삭제돼요. 그림은 항목의 첨부 파일에 남아요."
  },
  "worldPanel": {
    "checks": "검사",
    "findAndFixConsistencyIssuesIn": "세계관의 사실, 이벤트, 관계를 원고와 비교해요. AI는 쓰지 않아요.",
    "running": "실행 중…",
    "runChecks": "검사 실행",
    "lastRunAt": "마지막 실행 {{time}}",
    "oneAtATime": "한 번에 하나",
    "exclusiveRelation": "배타적 관계",
    "noRelationIsExclusive": "배타적인 관계 없음",
    "exclusivityType": "배타성 유형",
    "oneSourcePerTarget": "대상당 출처 하나",
    "oneTargetPerSource": "출처당 대상 하나",
    "oneAtATimeHint": "같은 시점에 하나만 성립할 수 있는 관계예요. 예를 들어 ‘소유한다’에서 같은 물건에 같은 시점의 소유자가 둘이면 충돌이에요.",
    "rulesNeedRelations": "규칙은 내 관계를 사용해요. ‘연결’에서 ‘소유한다’ 같은 관계를 추가한 뒤 여기서 배타적으로 설정하세요.",
    "results": "결과",
    "whatTheChecksLookFor": "검사 대상",
    "twoHoldersAtOnce": "동시에 두 소유자",
    "eventsOutOfOrder": "순서가 어긋난 이벤트",
    "quotedPastItsLimit": "허용 범위를 넘은 인용",
    "linksToDeletedEntries": "삭제된 항목으로의 링크",
    "notesThatLostTheirPlace": "자리를 잃은 노트",
    "relationsOverTime": "시간에 따른 관계",
    "scopeOwnership": "확정된 사실을 기준으로 같은 시점에 두 항목이 가진 하나의 대상이에요.",
    "scopeFlashback": "세계관에서 나중에 일어나는 이벤트보다 뒤에 읽히는 이벤트예요. 회상이거나 실수일 수 있어요.",
    "scopeReveal": "허용한 마지막 장면보다 뒤의 장면에서 인용된 사실이에요.",
    "scopeOrphans": "더 이상 존재하지 않는 항목이나 라이브러리 카드를 가리키는 노트와 사실이에요.",
    "scopeAnchors": "장면 안에서 문구가 옮겨졌거나 바뀐 인용 구절이에요.",
    "scopeRelations": "위의 규칙과 관계가 인용하는 본문에 대한 관계예요.",
    "filterResults": "결과 필터",
    "all": "전체",
    "conflicts": "충돌",
    "warnings": "경고",
    "needsData": "데이터 필요",
    "noIssuesFound": "문제가 없어요",
    "theExecutedRulesFoundNoViolation": "설정한 사실과 규칙을 어기는 것이 없어요. 검사는 내가 기록한 내용만 알아요.",
    "notEnoughData": "데이터가 부족해요",
    "quotesInTheText": "본문 속 인용",
    "anchorInPlace": "제자리",
    "anchorMoved": "옮겨짐",
    "anchorGone": "사라짐",
    "reAnchor": "다시 고정",
    "openScene": "장면 열기",
    "checkedAt": "{{time}}에 검사했어요.",
    "twoHold": "같은 시점에 “{{object}}”의 소유자가 둘이에요: {{a}}, {{b}}.",
    "heldTwice": "같은 시점에 {{a}}의 “{{object}}” 소유가 두 번 기록돼 있어요.",
    "flashbackSentence": "세계관에서는 “{{earlier}}” 이벤트가 “{{later}}” 이벤트보다 먼저 일어나지만 나중에 읽혀요. 의도한 회상이 아니라면 확인해 보세요.",
    "revealSentence": "허용한 마지막 장면 뒤인 {{scene}}에서 “{{fact}}” 사실이 인용돼요.",
    "allowedUpToScene": "{{scene}} 장면까지 허용",
    "orphanFactSentence": "사실(“{{fact}}”)이 삭제된 항목에 관한 것이에요.",
    "orphanNoteSentence": "“{{excerpt}}”에 대한 노트가 삭제된 항목을 가리켜요.",
    "orphanConceptSentence": "“{{excerpt}}”에 대한 노트가 더 이상 존재하지 않는 라이브러리 카드를 가리켜요.",
    "movedSentence": "{{scene}}에서 “{{excerpt}}” 구절이 옮겨졌어요. 노트를 다시 고정해 따라가게 하세요.",
    "eventWithoutTime": "세계관에서 시간이 없는 이벤트라 순서를 검사할 수 없어요: “{{title}}”",
    "factWithoutTime": "기간이 없는 사실이라 소유자를 검사할 수 없어요: “{{fact}}”",
    "recordWithoutTime": "기록에 시간이 없어서 검사할 수 없어요.",
    "aDeletedEntry": "삭제된 항목",
    "aDeletedEvent": "삭제된 이벤트",
    "aScene": "장면",
    "fromTo": "{{start}}부터 {{end}}까지",
    "relativeToAnEvent": "이벤트 기준",
    "timeNotSet": "설정 안 됨",
    "facts": "사실",
    "factsLead": "각 항목에 대해 내가 정한 사실이에요. 검사는 확정한 사실을 읽어 원고와 비교해요.",
    "entries": "항목",
    "addAnEntry": "항목 추가",
    "addTheFirstEntry": "첫 항목 추가",
    "newEntityName": "새 개체 이름",
    "entityType": "개체 유형",
    "addEntity": "개체 추가",
    "character": "인물",
    "place": "장소",
    "object": "사물",
    "faction": "세력",
    "other": "기타",
    "deleteEntityReferencesBecomeOrphaned": "개체 삭제(참조가 고아가 됨)",
    "deleteEntityName": "개체 {{name}} 삭제",
    "noFactYet": "{{name}}에 대한 사실이 아직 없어요. 새 사실은 ‘제안됨’으로 시작하며, 확정해야 적용돼요.",
    "proposed": "제안됨",
    "confirmed": "확정됨",
    "rejected": "거절됨",
    "superseded": "대체됨",
    "worldFact": "세계관 사실",
    "characterBelief": "믿음",
    "testimony": "증언",
    "authorHypothesis": "가설",
    "confirm": "확정",
    "confirmExplicitApproval": "확정(명시적 승인)",
    "newFactAbout": "{{name}}에 대한 새 사실",
    "predicatePlaceholder": "소유한다",
    "predicate": "술어",
    "valuePlaceholder": "그 검",
    "value": "값",
    "kind": "종류",
    "epistemicKind": "인식 유형",
    "kindHint": "세계관 사실만 진실로 간주해요. 믿음, 증언, 가설은 보관되지만 정설로 검사되지 않아요.",
    "when": "시점",
    "timeKind": "시간 유형",
    "betweenTwoMoments": "두 시점 사이",
    "from": "시작:",
    "to": "끝:",
    "startTick": "시작 틱",
    "endTick": "끝 틱",
    "momentsHint": "세계관 타임라인 위의 시점이에요. 끝은 포함하지 않아요.",
    "reveal": "공개 시점",
    "maximumRevealNarrativeIndex": "최대 공개 시점(서사 인덱스)",
    "noLimit": "제한 없음",
    "sceneNumbered": "{{n}}. {{title}}",
    "revealHint": "이 사실을 더 뒤의 장면에서 인용하면 표시돼요.",
    "addFactProposed": "제안됨으로 추가",
    "selectAnEntityToSeeAnd": "항목을 선택하면 해당 사실을 보고 추가할 수 있어요.",
    "noEntityYet": "아직 항목이 없어요. 위에서 또는 코덱스에서 인물, 장소, 사물을 추가하세요.",
    "resultDetails": "결과 세부 정보",
    "conflict": "충돌",
    "warning": "경고",
    "whatWasCompared": "비교한 내용",
    "whatToDo": "해야 할 일",
    "comparedOwnership": "시간 범위가 있는 확정된 세계관 사실이에요. 같은 대상의 두 소유자는 겹치면 안 돼요.",
    "comparedFlashback": "각 이벤트의 세계관 속 시간을 책 속 장면 순서와 비교해요.",
    "comparedReveal": "사실에 허용한 마지막 장면을 그 사실을 인용한 장면과 비교해요.",
    "comparedOrphans": "모든 노트와 사실을 현재 있는 항목과 라이브러리 카드와 비교해요.",
    "comparedAnchors": "각 노트의 인용을 장면의 현재 텍스트와 비교해요.",
    "confirmOnlyOneOwnerInThe": "그 시점에는 소유자를 한 명만 두세요. 시간 범위 하나를 좁히거나 사실 하나를 ‘제안됨’으로 되돌리세요.",
    "ifTheSceneIsADeliberate": "의도한 회상이라면 그대로 두세요. 아니면 장면을 옮기거나 이벤트의 시간을 바꾸세요.",
    "raiseTheMaximumRevealSceneOf": "그 사실에 더 뒤의 장면을 허용하거나 인용을 앞으로 옮기세요.",
    "restoreTheMissingEntityFromThe": "코덱스 기록에서 항목을 복원하거나, 그 항목을 가리키는 노트나 사실을 삭제하세요.",
    "useReAnchorManualOnThe": "결과에서 인용의 ‘다시 고정’을 사용하거나, 장면을 열고 구절을 다시 선택하세요.",
    "giveTheEventOrFactAn": "세계관 속 시간을 지정하거나 비워 두세요. 검사는 추측하지 않고 가만히 있어요.",
    "selectAResult": "결과 선택",
    "detailsConstraintsAndSuggestedFixesAppear": "비교한 내용과 해야 할 일이 여기에 표시돼요.",
    "thisAnnotationCannotBeReAnchored": "이 노트를 다시 고정할 수 없어요. “{{excerpt}}” 구절이 장면에 없거나 두 번 이상 나와요.",
    "revisionTools": "퇴고 도구",
    "loadingRevisionTools": "퇴고 도구 불러오는 중…"
  },
  "worldReplicationPanel": {
    "theContentChangedWhileItWas": "확인하는 동안 내용이 바뀌었어요. 검토한 내용과 승인을 선택하세요.",
    "theseChangesCannotBeCombinedInto": "이 변경 사항들은 유효한 세계관으로 합칠 수 없어요. 유지할 완전한 버전을 선택하세요. 두 사본 모두 복구용으로 남아요.",
    "thisDevice": "이 기기",
    "yourAccount": "내 계정",
    "viewWorld": "세계관 보기",
    "previousSharedValue": "이전 공유 값",
    "theActionCouldNotFinishYour": "작업을 완료하지 못했어요. 로컬 변경 사항은 유지돼요.",
    "worldSync": "세계관 동기화",
    "syncCodexPagesFactsTimelinesCollections": "코덱스 페이지, 사실, 타임라인, 컬렉션, 첨부 파일을 기기 간에 동기화해요. 노트와 스케치는 아래에서 별도로 동기화돼요.",
    "syncWorldAutomatically": "세계관 자동 동기화",
    "n1PendingChange": "대기 중인 변경 1건",
    "pendingPendingChanges": "대기 중인 변경 {{pending}}건",
    "syncNow": "지금 동기화",
    "exportRecoveryCopies": "복구 사본 내보내기",
    "compareBeforeSyncing": "동기화 전 비교",
    "signInToTheLinkedAccount": "연결된 계정에 로그인해 동기화하세요. 로컬 변경 사항은 그대로 저장돼요.",
    "signInToCompareYourWorld": "세계관을 비교하고 동기화를 켜려면 로그인하세요.",
    "chooseYourStartingWorld": "시작할 세계관 선택",
    "bothCopiesHaveTheSameContent": "두 사본의 내용이 같아요.",
    "keepTheWorldOnThisDevice": "이 기기의 세계관을 유지하거나 계정의 사본을 사용하세요. 이전 로컬 세계관과 첨부 파일은 복구용으로 보관돼요.",
    "keepThisDeviceSync": "이 기기 유지 후 동기화",
    "useAccountCopySync": "계정 사본 사용 후 동기화",
    "cancel": "취소",
    "reviewConcurrentChanges": "동시 변경 검토",
    "chooseEachValueToKeepOther": "유지할 값을 각각 선택하세요. 다른 변경 사항은 자동으로 병합돼요. 두 버전 모두 복구할 수 있어요.",
    "applyReviewedChoices": "검토한 선택 적용",
    "syncingWorldAndAttachments": "세계관과 첨부 파일 동기화 중…",
    "codexPages": "코덱스 페이지",
    "onThisDevice": "이 기기",
    "waitingToSync": "동기화 대기 중",
    "syncing": "동기화 중…",
    "upToDate": "최신 상태",
    "reviewNeeded": "검토 필요",
    "emptyText": "(빈 텍스트)",
    "emptyList": "(빈 목록)",
    "worldStructure": "세계관 구조",
    "labelFacts": "사실",
    "labelEvents": "이벤트",
    "labelKnowledge": "지식",
    "labelAnnotations": "주석",
    "labelRelationships": "관계",
    "labelAttachments": "첨부 파일",
    "labelCollections": "컬렉션",
    "labelFolders": "폴더",
    "paused": "일시 정지됨",
    "addedCount_other": "추가 {{count}}건",
    "removedCount_other": "삭제 {{count}}건",
    "changedCount_other": "변경 {{count}}건",
    "removedValue": "삭제됨",
    "emptyValue": "비어 있음"
  },
  "worldReviewTools": {
    "deletedEntry": "삭제된 항목",
    "timeUnknown": "시간을 알 수 없음",
    "storyTimeInterval": "이야기 시간 구간",
    "relativeToEventPreserved": "이벤트 기준(보존됨)",
    "from": "시작:",
    "until": "종료:",
    "characterKnowledge": "인물의 지식",
    "couldNotCheckTheSavedManuscriptRetry": "저장된 원고를 검사하지 못했어요. 다시 시도해 주세요.",
    "revisionTools": "퇴고 도구",
    "changeImpact": "변경 영향",
    "whatPointsToThisRecord": "이 기록을 가리키는 것은 무엇인가요?",
    "explicitLinksOnlyIncludingIndirectLinksChangingARecord": "간접 링크를 포함해 명시적 링크만 보여 줘요. 기록을 바꿔도 의존하는 기록이 고쳐지지는 않아요.",
    "impactRecord": "영향 기록",
    "chooseARecord": "기록 선택",
    "linkedRecordsWorldRevision": "연결된 기록 · 세계관 리비전",
    "directLink": "직접 링크",
    "missingSourceScene": "누락된 출처 장면",
    "noExplicitRecordLinksToThisEntryUnlinkedProse": "이 항목으로 가는 명시적 기록 링크가 없어요. 링크되지 않은 본문은 이 검사 범위 밖이에요.",
    "whenDidTheyLearnIt": "언제 알게 되었나요?",
    "recordAcquisitionAndUseOnTheSameStoryTime": "습득과 사용을 같은 이야기 시간축에 기록하세요. 추측과 믿음은 따로 두며, 챕터 순서는 이야기 시간으로 취급하지 않아요.",
    "recordKnowledge": "지식 기록",
    "couldNotSaveCheckTheIntervalsOrCancelAnd": "저장하지 못했어요. 구간을 확인하거나, 세계관이 바뀌었다면 취소하고 다시 여세요.",
    "character": "인물",
    "knowledgeCharacter": "지식의 인물",
    "chooseACharacter": "인물 선택",
    "fact": "사실",
    "knowledgeFact": "지식의 사실",
    "chooseAConfirmedWorldFact": "확정된 세계관 사실 선택",
    "acquired": "습득",
    "acquisitionSource": "습득 출처",
    "noSourceAttached": "출처 없음",
    "use": "사용",
    "scene": "장면",
    "chooseAScene": "장면 선택",
    "knownInformation": "알려진 정보",
    "belief": "믿음",
    "guess": "추측",
    "passageSource": "구절 출처",
    "noPassageAttached": "구절 없음",
    "removeUse": "사용 삭제",
    "addUse": "사용 추가",
    "confirmAndSave": "확인 및 저장",
    "cancel": "취소",
    "missingFact": "누락된 사실",
    "atUnknownRelativeTime": "알 수 없거나 상대적인 시간에",
    "edit": "편집",
    "couldNotRemoveTheRecordRefreshAndRetry": "기록을 삭제하지 못했어요. 새로 고침 후 다시 시도하세요.",
    "checkSavedKnowledge": "저장된 지식 검사",
    "theWorldChangedSinceThisResultRunTheCheck": "이 결과 이후 세계관이 바뀌었어요. 검사를 다시 실행하세요.",
    "recordedUseIsEarlierThanAcquisition": "기록된 사용이 습득보다 앞서요",
    "recordedTimesAreInOrder": "기록된 시간 순서가 맞아요",
    "beliefOrGuessNotAKnowledgeConflict": "믿음 또는 추측이라 지식 충돌이 아니에요",
    "notEnoughInformationToCompare": "비교할 정보가 부족해요",
    "attachedPassagesMatchTheSavedText": "첨부된 구절이 저장된 텍스트와 일치해요",
    "aSourceIsMissingStaleOrBelongsToAnother": "출처가 없거나 오래되었거나 다른 장면에 속해요",
    "authorRecordedTimesPassagesAreNotVerified": "작가가 기록한 시간이에요. 구절은 검증되지 않아요",
    "openScene": "장면 열기",
    "noConfirmedKnowledgeUsesToCompare": "비교할 확정된 지식 사용이 없어요.",
    "openNamedScene": "{{title}} 열기",
    "recordSummary": "사용: {{count}} · {{lifecycle}} · 습득 {{time}}",
    "checkSummary": "{{time}}에 검사 · 기록된 사용 {{count}}건. 본문을 수정한 뒤 새로 고침하세요.",
    "resultsLimitedTo500Records": "결과는 500개 기록까지만 표시됩니다",
    "linksAway": "링크 {{depth}}단계 떨어짐",
    "useNKind": "사용 {{n}} 유형",
    "useN": "사용 {{n}}",
    "useNSource": "사용 {{n}} 출처",
    "checking": "확인하는 중…"
  },
  "worldSection": {
    "overview": "개요",
    "vault": "보관함",
    "timeline": "타임라인",
    "connections": "연결",
    "references": "참조",
    "checks": "검사",
    "analysis": "분석",
    "characters": "인물",
    "locations": "장소",
    "factions": "세력",
    "objects": "사물",
    "concepts": "개념",
    "worldViews": "세계관 보기",
    "world": "세계관",
    "browseByType": "유형별 둘러보기",
    "filterByType": "유형으로 필터",
    "all": "전체",
    "newEntry": "새 항목",
    "cercaNelCodex": "코덱스 검색",
    "searchEntries": "항목 검색…",
    "entry": "항목",
    "entries": "항목",
    "alsoAliases": "별칭: {{aliases}}",
    "noEntriesYetCreateTheFirst": "아직 항목이 없어요. 첫 인물, 장소, 세력을 만들어 보세요.",
    "noEntryMatches": "일치하는 항목이 없어요.",
    "editName": "{{name}} 편집",
    "edit": "편집",
    "archive": "보관",
    "confirmArchive": "보관 확인",
    "notesAndSketches": "노트와 스케치",
    "alsoKnownAs": "다른 이름",
    "addADescriptionOneLineThat": "설명을 추가하세요 — 이게 무엇인지 한 줄로 적어요.",
    "none": "없음",
    "yes": "예",
    "no": "아니요",
    "removedEntry": "삭제된 항목",
    "unavailableEntry": "사용할 수 없는 항목",
    "noNotesYetEditTheEntry": "아직 노트가 없어요. 항목을 편집해 설명을 적어 보세요.",
    "linkedScenes": "연결된 장면",
    "showTheEntriesOfABook": "책별 항목 보기",
    "allBooks": "모든 책",
    "bookLine": "{{number}}권 · {{title}}",
    "inNoBookYet": "아직 어느 책에도 없음",
    "scenesThatMentionThisEntryBy": "이름이나 별칭으로 이 항목을 언급한 장면이 여기에 표시돼요.",
    "facts": "사실",
    "noFactRecordedFactsAreAdded": "기록된 사실이 없어요. 사실은 검사에서 추가하고 승인해요.",
    "relations": "관계",
    "noRelationYet": "아직 관계가 없어요.",
    "proposed": " · 제안됨",
    "viewAll": "모두 보기",
    "attachments": "첨부 파일",
    "attachAnImageToUseIt": "이미지를 첨부하면 초상화로 쓸 수 있어요.",
    "kib": "KiB",
    "open": "열기",
    "remove": "삭제",
    "addAttachment": "첨부 파일 추가",
    "stateAtStoryTime": "이야기 시간 기준 상태",
    "tick": "틱",
    "factsWithoutACompleteInterval": "기간이 완전하지 않은 사실이에요.",
    "selectAnEntry": "항목 선택",
    "charactersPlacesFactionsAndObjectsLive": "인물, 장소, 세력, 사물이 사실, 관계, 첨부 파일과 함께 이곳에 있어요.",
    "recentChanges": "최근 변경",
    "undoChange": "변경 취소",
    "worldTimeline": "세계관 타임라인",
    "eventsPeopleAndPlacesInA": "더 큰 맥락에서 본 이벤트, 인물, 장소예요.",
    "noEventYet": "아직 이벤트가 없어요",
    "addTheFirstEventWithA": "이야기 속 시간과 함께 첫 이벤트를 추가하세요. 시간을 모르면 알게 될 때까지 비워 둬도 돼요.",
    "tick2": "틱",
    "plotEvent": "플롯 이벤트",
    "worldEvent": "세계관 이벤트",
    "openScene": "장면 열기",
    "unknownTime": "알 수 없는 시간",
    "unknown": "알 수 없음",
    "seeHowYourWorldSPeople": "세계관의 인물, 장소, 아이디어가 어떻게 이어지는지 보세요.",
    "connectionsView": "연결 보기",
    "graph": "그래프",
    "list": "목록",
    "nothingToConnectYet": "아직 연결할 것이 없어요",
    "createEntriesInTheCodexAnd": "코덱스에 항목을 만들고 목록 보기에서 서로 관계를 지정하세요.",
    "selectedEntry": "선택한 항목",
    "relationSummary": "관계 요약",
    "noSceneMentionsThisEntryYet": "이 항목을 언급한 장면이 아직 없어요.",
    "openInCodex": "코덱스에서 열기",
    "selectANodeToSeeIts": "노드를 선택하면 관계와 장면을 볼 수 있어요.",
    "annotationsAnchoredInTheManuscriptAnd": "원고에 고정된 주석과 세계관용으로 보관하는 파일이에요.",
    "addFile": "파일 추가",
    "annotations": "주석",
    "selectTextInTheManuscriptAnd": "원고에서 텍스트를 선택하고 ‘주석’을 사용해 기법, 개체 또는 노트를 고정하세요.",
    "scene": "장면",
    "device": "기법",
    "entity": "개체",
    "note": "노트",
    "imagesPdfsNotesAndAudioYou": "세계관이나 항목에 첨부한 이미지, PDF, 노트, 오디오예요.",
    "linked": "연결됨",
    "orphan": "고아",
    "openFile": "파일 열기",
    "referenceDetails": "참조 세부 정보",
    "textAnnotation": "텍스트 주석",
    "kind": "종류",
    "anchor": "앵커",
    "concept": "개념",
    "created": "생성일",
    "anchorStatesValidStaleOrphanedAnd": "앵커 상태(유효, 오래됨, 고아)와 다시 고정은 검사에서 계산해요.",
    "attachment": "첨부 파일",
    "type": "유형",
    "size": "크기",
    "linkedTo": "연결 대상",
    "added": "추가일",
    "confirmRemove": "삭제 확인",
    "selectAnAnnotationOrAFile": "주석이나 파일을 선택하세요.",
    "exploreTheShapeOfYourStory": "이야기의 모양을 살펴보세요. 장면별 분량, 등장 빈도, 밀도를 볼 수 있어요.",
    "sceneLength": "장면 분량",
    "wordsPerScene": "장면별 단어 수",
    "noScenesYet": "아직 장면이 없어요.",
    "titleFmtWords": "{{title}}: {{fmt}}단어",
    "entityDensity": "개체 밀도",
    "codexMentionsPerScene": "장면별 코덱스 언급",
    "titleMentionsMentions": "{{title}}: 언급 {{mentions}}회",
    "characterAppearanceMap": "인물 등장 지도",
    "aDotWhereACharacterIs": "장면에서 인물이 언급된 곳에 점이 찍혀요",
    "addCharactersToTheCodexAnd": "코덱스에 인물을 추가하고 장면에서 이름을 불러 보세요.",
    "thisScene": "이 장면",
    "words": "단어",
    "paragraphs": "문단",
    "sentencesEst": "문장(추정)",
    "distinctWords": "고유 단어",
    "annotatedDevices": "주석 단 기법",
    "n1000Words": "/ 1,000단어",
    "repetitions": "반복",
    "exportHtml": "HTML 내보내기",
    "exportTxt": "TXT 내보내기",
    "events": "이벤트",
    "confirmedFacts": "확정된 사실",
    "recentlyChanged": "최근 변경",
    "changesToTheWorldWillBe": "세계관의 변경 사항이 여기에 나열되며, 각각 되돌릴 수 있어요.",
    "undo": "되돌리기",
    "startHere": "여기서 시작",
    "overviewEmptyLead": "이야기의 인물, 장소, 이벤트가 등장하는 장면과 연결돼요.",
    "addACharacter": "인물 추가",
    "addACharacterText": "누구인지, 무엇을 원하는지, 무엇이 가로막는지 적어 보세요.",
    "addAPlace": "장소 추가",
    "addAPlaceText": "장면이 일어나는 곳이에요. 도시, 배, 방 하나도 좋아요.",
    "addAnEventText": "이야기에서 일어나는 일을 날짜와 함께 또는 날짜 없이 적어 보세요.",
    "inThisWorld": "이 세계관에서",
    "createAnEntry": "항목 만들기",
    "aCharacterAPlaceAFaction": "인물, 장소, 세력, 사물 또는 개념이에요.",
    "addAnEvent": "이벤트 추가",
    "withAnExactStoryTimeOr": "정확한 이야기 시간 또는 알 수 없는 시간으로 추가해요.",
    "runTheChecks": "검사 실행",
    "deterministicRulesOwnershipOrderAnchorsOrphans": "소유자, 순서, 공개 시점, 시간에 따른 관계를 본문과 비교해요.",
    "loadingTheWorld": "세계관 불러오는 중…",
    "maps": "지도",
    "openItsMap": "해당 지도 열기",
    "addAMap": "지도 추가",
    "pinnedOn": "핀이 놓인 곳:",
    "typeCharacter": "인물",
    "typeLocation": "장소",
    "typeObject": "사물",
    "typeFaction": "세력",
    "typeConcept": "개념",
    "annotationsToReAnchor_other": "다시 고정할 주석 {{count}}개."
  }
}
